var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.304321,
    width: 18.2935,
    height: 18.2935,
    rx: 2.15217,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1082_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 14,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.11395,
    y: 2.11395,
    width: 13.886,
    height: 13.886,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1082_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84967 8.4784V3.84972H8.47835V8.4784H3.84967ZM5.00684 7.32123H7.32118V5.00689H5.00684V7.32123ZM3.84967 14.2643V9.63557H8.47835V14.2643H3.84967ZM5.00684 13.1071H7.32118V10.7927H5.00684V13.1071ZM9.63552 8.4784V3.84972H14.2642V8.4784H9.63552ZM10.7927 7.32123H13.107V5.00689H10.7927V7.32123ZM13.107 14.2643V13.1071H14.2642V14.2643H13.107ZM9.63552 10.7927V9.63557H10.7927V10.7927H9.63552ZM10.7927 11.9499V10.7927H11.9499V11.9499H10.7927ZM9.63552 13.1071V11.9499H10.7927V13.1071H9.63552ZM10.7927 14.2643V13.1071H11.9499V14.2643H10.7927ZM11.9499 13.1071V11.9499H13.107V13.1071H11.9499ZM11.9499 10.7927V9.63557H13.107V10.7927H11.9499ZM13.107 11.9499V10.7927H14.2642V11.9499H13.107Z",
    fill: "#FCFCFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr_icon.c297a552dfdf95f71e5e96f5de07a87b.svg";
export { ForwardRef as ReactComponent };